module.exports = __webpack_public_path__ + "img/resultCircle.f7cc20af.png";